<template>
    <div>
        <form @submit.prevent="logIn" :novalidate="!isLogIn">
            <EmailInput ref="emailInput" v-model="email" :hideBtn="isLogIn" />
            <b-collapse :visible="isLogIn" id="logInFormCollapse">
                <TextField
                    ref="passwordField"
                    class="my-4"
                    :placeholder="$t('general.password')"
                    :label="$t('general.password')"
                    type="password"
                    v-model="password"
                    padding
                    required
                    :helperText="errorMessage"
                    :error="errorMessage !== ''"
                />
                <BaseButton
                    class="w-100 pa-2 mt-4"
                    variant="primary"
                    type="submit"
                >
                    {{ $t('shared.loginModule.logInForm.logIn') }}
                </BaseButton>
                <div class="mt-5 d-flex justify-content-center">
                    <BaseButton
                        variant="text-primary"
                        @click.native.prevent="onResetPassword"
                    >
                        {{ $t('shared.loginModule.logInForm.forgotPassword') }}
                    </BaseButton>
                </div>
            </b-collapse>
        </form>
    </div>
</template>

<script>
import states from '../states';
import Token from '~/api/Token';
import { logInErrorMapper as errorMapper } from '~/utils/errors/authErrorMapper';

// Components
import EmailInput from './EmailInput';

export default {
    name: 'LogInForm',
    components: { EmailInput },
    props: {
        value: Boolean, // IsLoading
        isLogIn: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        email: '',
        password: '',
        errorMessage: '',
    }),
    methods: {
        focusOnPassword() {
            this.$nextTick(() => {
                this.$refs.passwordField.focus();
            });
        },
        focusOnEmail() {
            this.$nextTick(() => {
                this.$refs.emailInput.focus();
            });
        },
        setLoading(value) {
            this.$emit('input', value);
        },
        logIn() {
            if (this.isLogIn === false) {
                this.$emit('stateChange', states.LOGIN);
                return;
            }

            this.setLoading(true);
            this.$interfaces.token
                .post({
                    body: {
                        email: this.email,
                        password: this.password,
                    },
                })
                .then(async data => {
                    // Get user data
                    await this.$interfaces.user.me
                        .get({ forceUpdate: true })
                        .then(() => {
                            this.onLogIn();
                        });
                })
                .catch(error => {
                    this.errorMessage = errorMapper(error);
                    // this.deferredEmailFocus();
                })
                .finally(() => {
                    this.$emit('input', false);
                });
        },
        onResetPassword() {
            this.$emit('stateChange', states.FORGOT_PASSWORD);
        },
        onLogIn() {
            this.$emit('login');
        },
    },
    computed: {
        credentials: function() {
            return this.email + this.password;
        },
    },
    watch: {
        credentials() {
            this.errorMessage = '';
        },
    },
};
</script>

<style scoped></style>
